import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ca1448a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "header" }, "Attachment", -1))
const _hoisted_3 = { class: "mt-3" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "w-100 mt-3 text-right" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_CommonButton = _resolveComponent("CommonButton")!

  return (_ctx.isBusy)
    ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_ctx.selectedItem)
            ? (_openBlock(), _createElementBlock("label", _hoisted_4, _toDisplayString(_ctx.selectedItem), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachmentOptions, (option, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (option.text === 'Add Attachment')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("input", {
                      type: "file",
                      name: "add",
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setFile && _ctx.setFile(...args)))
                    }, null, 32),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_CommonButton, {
                        type: _ctx.ButtonType.Primary,
                        disabled: !_ctx.fileToUpload,
                        text: '+ Add',
                        onClick: ($event: any) => (_ctx.AttachmentAction(option.action))
                      }, null, 8, ["type", "disabled", "onClick"])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "d-block",
                      onClick: _withModifiers(($event: any) => (_ctx.AttachmentAction(option.action)), ["stop","prevent"])
                    }, _toDisplayString(option.text), 9, _hoisted_8)
                  ]))
            ], 64))
          }), 256))
        ])
      ]))
}